<template>
  <SignUpTemplate
    :left-title="$t('Views.user_signup.left_side.title')"
    :left-subtitle="$t('Views.user_signup.left_side.subtitle')"
  >
    <AlreadyHaveAccount :show="showHaveAccount" />
    <ul class="navigator">
      <div class="navigator__wrapper">
        <SignUpBullet
          :number="1"
          :done="getStepNumber"
          :form="done"
          to="./step1"
        />
        <SignUpBullet
          :number="2"
          :done="getStepNumber"
          :form="done"
          to="./step2"
        />
        <SignUpBullet
          :number="3"
          :done="getStepNumber"
          :form="done"
          to="./step3"
        />
        <SignUpBullet
          :number="4"
          :done="getStepNumber"
          :form="done"
          to="./step4"
        />
      </div>
    </ul>
    <Transition
      :name="transitionClass"
      @on:before-enter="() => lastStep(getStepNumber)"
    >
      <RouterView />
    </Transition>
  </SignUpTemplate>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { SignUpBullet, SignUpTemplate, AlreadyHaveAccount } from '@/domains/Auth/components';
import { EMPLOYEE_MODULE } from '@/constants/modules';

import { steps } from './constants';

export default {
  components: {
    SignUpBullet,
    AlreadyHaveAccount,
    SignUpTemplate,
  },
  computed: {
    ...mapState(EMPLOYEE_MODULE, {
      done: state => state.done,
      currentStep: state => state.currentStep,
      lastStepNumber: state => state.lastStep,
    }),
    showHaveAccount() {
      return this.currentStep === steps.step1;
    },
    getStepNumber() {
      const route = this.$route.name.match(/\d+/);
      return route ? parseInt(route[0], 0) : 1;
    },
    transitionClass() {
      return this.lastStepNumber > this.getStepNumber ? 'slide-fade-fallback' : 'slide-fade';
    },
  },
  methods: {
    ...mapMutations(EMPLOYEE_MODULE, ['lastStep']),
  },
};
</script>
